import React from 'react';
import HorizontalBoxPlot from './horizontal-box-plot';
import AcceptanceClassificationTooltip from './acceptance-likelihood/acceptance-classification-tooltip';
import {acceptanceLikelihoodClassification} from 'shared/college-profile/utils';
import GpaTooltip from 'shared/components/gpa-modal/tooltip';

interface Props {
  college: {
    averageGPA: number;
    name: string;
  };
  userInfo: {
    highSchoolInfo: {
      gpa: number;
    };
  };
  showAdmissability: boolean;
}

const GPASection = ({college, userInfo, showAdmissability}: Props) => {
  const averageGPA = college.averageGPA;
  const gpa = userInfo.highSchoolInfo.gpa;

  const getAcceptanceLikelihoodClassification = () => {
    const lowerBound = averageGPA - 0.2;
    const upperBound = averageGPA + 0.2;

    return acceptanceLikelihoodClassification(gpa, lowerBound, upperBound);
  };

  const formatGPA = (n: number) => {
    if (n % 1 === 0) {
      return `${n}.0`;
    }

    return n;
  };

  if (!averageGPA) {
    return null;
  }

  const points = [
    {
      value: averageGPA,
      color: showAdmissability ? 'gray' : 'blue',
      label: `Avg GPA: ${formatGPA(averageGPA)}`,
    },
  ];

  if (showAdmissability && gpa) {
    points.push({
      value: gpa,
      color: 'blue',
      label: `Your GPA: ${formatGPA(gpa)}`,
    });
  }

  return (
    <div className="college-profile-sat-act">
      <header className="college-profile-sat-act-header">
        Average GPA
        {showAdmissability && <GpaTooltip />}
      </header>
      {showAdmissability && (
        <div className="college-profile-sat-act-subheader">
          {gpa ? (
            `Compare your GPA to ${name}'s averages. `
          ) : (
            <a href="/portfolio#courses" className="">
              Enter more courses to compare GPA averages.
            </a>
          )}
        </div>
      )}
      <div className="college-profile-sat-act-range">
        <div className="college-profile-sat-act-plot">
          {(showAdmissability || true) && gpa && (
            <AcceptanceClassificationTooltip
              label="Your GPA"
              studentValue={formatGPA(gpa)}
              classification={getAcceptanceLikelihoodClassification()}
              xValue={(gpa / 4) * 100}
            />
          )}
          <HorizontalBoxPlot
            min={0.0}
            minLabel="0.0"
            max={4.0}
            maxLabel="4.0"
            points={points}
            tooltip={(showAdmissability || true) && !!gpa}
          />
        </div>
        <div className="college-score-range-label">
          <div className="college-score-range-label-content">{averageGPA}</div>
        </div>
      </div>
    </div>
  );
};

export default GPASection;
